import { useFpB2bCartCalculate } from '@cart-services/hooks/fp-b2b/use-fp-b2b-cart-calculate'
import { useDialog } from '@dni-hooks/useDialog'
import { Dialog } from '@mui/material'
import { Box } from '@pets-ui/Box/Box'
import { Button } from '@pets-ui/Button/Button'
import { Text } from '@pets-ui/Text/Text'
import { colors } from '@pets-ui/tokens/colors.stylex'
import { VStack } from '@pets-ui/VStack/VStack'
import * as stylex from '@stylexjs/stylex'
import { useStmCart } from '../../CartProvider'

const styles = stylex.create({
  container: {
    padding: 16,
    gap: 8,
    backgroundColor: colors.grey100,
    width: 320,
  },
})

export const DIALOG_CART_THRESHOLD = 'DIALOG_CART_THRESHOLD'

export const DialogCartThreshold = () => {
  const { open, closeDialog } = useDialog(DIALOG_CART_THRESHOLD)
  const { campaignId, campaignCode, platform } = useStmCart()
  const { calculateResult } = useFpB2bCartCalculate(campaignId, campaignCode, platform)
  const noticeInfo = calculateResult?.notice_info

  return (
    <Dialog disablePortal open={open} PaperProps={{ sx: { borderRadius: '8px' } }}>
      <VStack rootStyle={[styles.container]}>
        <Box display="flex" justifyContent="center">
          <Text variant="h4">未達最低消費金額</Text>
        </Box>
        <Box>
          <Text variant="body" color={colors.grey800}>本活動有設定可出貨的最低消費金額 ，未達者無法結帳。</Text>
          {
            noticeInfo?.map((info) => {
              return <Text key={info.message} variant="body" color={colors.grey800}>{`- ${info.message}`}</Text>
            })
          }
        </Box>
        <Button onClick={closeDialog}>我知道了</Button>
      </VStack>
    </Dialog>
  )
}
